/* tslint:disable */
/* eslint-disable */
/**
 * AgentAssistService
 * Agent Assist API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ListContactMetadataColumnsResponseContent
 */
export interface ListContactMetadataColumnsResponseContent {
    /**
     * 
     * @type {Array<string>}
     * @memberof ListContactMetadataColumnsResponseContent
     */
    columnsList?: Array<string>;
}


/**
 * Check if a given object implements the ListContactMetadataColumnsResponseContent interface.
 */
export function instanceOfListContactMetadataColumnsResponseContent(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ListContactMetadataColumnsResponseContentFromJSON(json: any): ListContactMetadataColumnsResponseContent {
    return ListContactMetadataColumnsResponseContentFromJSONTyped(json, false);
}

export function ListContactMetadataColumnsResponseContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListContactMetadataColumnsResponseContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'columnsList': !exists(json, 'columnsList') ? undefined : json['columnsList'],
    };
}

export function ListContactMetadataColumnsResponseContentToJSON(value?: ListContactMetadataColumnsResponseContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'columnsList': value.columnsList,
    };
}

